const requiredProfileFields = ["email", "firstName", "lastName"];
const signupDetailFields = ["firstName", "lastName", "phoneNumber"];

function hasText(value) {
  return typeof value === "string" && value.trim().length > 0;
}

export function hasPhoneNumber(value) {
  // Some older profiles store their phone number as a number rather than text.
  return (
    hasText(value) ||
    (typeof value === "number" && Number.isFinite(value) && value > 0)
  );
}

export function hasRequiredProfileDetails(profile) {
  return (
    requiredProfileFields.every((field) => hasText(profile?.[field])) &&
    hasPhoneNumber(profile?.phoneNumber)
  );
}

function missingIdentityFields(profile, user, details) {
  const identity = { email: user.email, userId: user.uid };
  for (const field of signupDetailFields) {
    identity[field] = details[field];
  }

  const updates = {};
  for (const [field, value] of Object.entries(identity)) {
    const missing =
      field === "phoneNumber"
        ? !hasPhoneNumber(profile[field])
        : !hasText(profile[field]);
    if (missing && hasText(value)) {
      updates[field] = value.trim();
    }
  }
  return updates;
}

export async function initializeUserProfile(database, user, details = {}) {
  const document = database.collection("Users").doc(user.uid);

  return database.runTransaction(async (transaction) => {
    const snapshot = await transaction.get(document);
    const storedProfile = snapshot.exists
      ? snapshot.data()
      : { userType: "individual", basketItems: [] };
    const updates = missingIdentityFields(storedProfile, user, details);
    const profile = { ...storedProfile, ...updates };

    if (!snapshot.exists) {
      transaction.set(document, profile);
    } else if (Object.keys(updates).length > 0) {
      transaction.update(document, updates);
    }

    return {
      ...profile,
      userType: profile.userType ?? "individual",
      basketItems: profile.basketItems === undefined ? [] : profile.basketItems,
    };
  });
}
